<template>
  <div class="pr-2 pl-2 mt-5">
    <div class="vx-row">
      <div class="vx-col md:w-2/12 sm:w-full w-full" v-if="queueReportStatus === 1">
        <statistics-item-card
          class="mb-3"
          :title="$t('response_rate')"
          :display="`${queueDetails.asf}%`"
          :is-loading="isLoading"
          tool-tip-title="( 통화수 X 100 / ( 통화 수 + 포기 호) ) 의 값">
        </statistics-item-card>

        <statistics-item-card
          v-if="false"
          class="mb-3"
          :is-loading="isLoading"
          :display="`${queueDetails.tsf}%`">
        </statistics-item-card>

        <statistics-item-card
          class="mb-3"
          :title="$t('call_pending')"
          :display="queueDetails.totalCalls"
          :is-loading="isLoading"
          tool-tip-title="현재 Queue 에 대기 중인 콜 수">
        </statistics-item-card>

        <statistics-item-card
          class="mb-3"
          :title="$t('estimated_wait_time')"
          :display="queueDetails.holdTime"
          :is-loading="isLoading"
          tool-tip-title="예상 대기 시간">
        </statistics-item-card>

        <statistics-item-card
          class="mb-3"
          :title="$t('average_talk_time')"
          :display="queueDetails.talkTime"
          :is-loading="isLoading"
          tool-tip-title="평균 통화 시간">
        </statistics-item-card>

        <statistics-item-card class="mb-3" :title="$t('queue_data_analization')" v-if="$store.getters.hasCompanyPermission('company_hide_reset_button_for_queues') == false">
          <template v-slot:actionButton>
            <div class="text-center p-4">
              <reset-queue-button :server="server" :queue="queue"></reset-queue-button>
            </div>
          </template>
        </statistics-item-card>
        <div class="vx-card" v-if="$store.getters.hasCompanyPermission('company_hide_reset_button_for_queues') == false">
          <div class="vx-card__collapsible-content">
            <div class="vx-card__body p-3">
              <div
                class="vx-row"
              >
                <div class="vx-col md:w-1/2 sm:w-full w-full" style="text-align: center;padding: 0.7rem !important;" v-text="$t('extension_number')" />
                <div class="vx-col md:w-1/2 sm:w-full w-full">
                  <vs-input v-model="extensionNumber" class="w-full"/>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="vx-col sm:w-full w-full" :class="{'md:w-10/12': queueReportStatus === 1, 'md:w-12/12': queueReportStatus === 0}">
        <div
          v-if="queueReportStatus === 1"
          class="vx-row"
        >
          <div class="vx-col md:w-1/3 sm:w-full w-full">
            <statistics-item-card
              class="mb-3"
              :title="$t('total_incoming_call')"
              :is-loading="isLoading"
              :display="queueDetails.totalIncomingCalls">
            </statistics-item-card>
          </div>

          <div class="vx-col md:w-1/3 sm:w-full w-full">
            <statistics-item-card
              class="mb-3"
              :title="$t('answer_call')"
              :is-loading="isLoading"
              :display="queueDetails.answeredCalls">
            </statistics-item-card>
          </div>

          <div class="vx-col md:w-1/3 sm:w-full w-full">
            <statistics-item-card
              class="mb-3"
              :title="$t('abandonment_issue')"
              :is-loading="isLoading"
              :display="queueDetails.droppedCalls">
            </statistics-item-card>
          </div>
        </div>

        <div id="statusDataContainer" class="vs-con-loading__container">
          <extensions :runInitialExtensions="pullUpdatedExtensions" :extensions="extensions" :queue="queue" :server="server" :state="state" :extensionNumber="extensionNumber" :activeExtensions="activeExtensions"></extensions>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StatisticsItemCard from '@/components/cards/StatisticsItemCard'
import ResetQueueButton from '@/components/buttons/ResetQueueButton'
import Extensions from '@/views/Shared/Queues/Extensions'
import Node from '@/models/Node'
import User from '@/models/User'

import io from 'socket.io-client'
import Moment from 'moment'

export default {
  name: 'Window.Queues.Status',
  components: {
    StatisticsItemCard,
    ResetQueueButton,
    Extensions
  },
  data () {
    return {
      queueReportStatus: this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.queue_report_status !== null ? this.$store.getters.userInfo.queue_report_status : 0 : 0,
      socket: {},
      server: {},
      queueStatusNode: {},

      extensions: [],
      queueDetails: {
        answeredCalls: 0, // callsAnswered
        droppedCalls: 0, // callsAbandoned
        asf: 0,
        tsf: 0,
        slt: 0,

        strategy: '',
        totalCalls: 0, // noofcalls
        holdTime: '00:00:00', // expectedWaitTime
        notAnswered: 0,

        talkTime: 0,
        totalIncomingCalls: 0 // callsoffered
      },
      cacheExt: {},
      isLoading: true,
      testExtension: 1,
      state: {
        listen: false,
        whisper: false,
        currentNumber: null
      },
      extensionNumber: '',
      activeExtensions: []
    }
  },
  computed: {
    queue () {
      return this.$route.query.queue
    }
  },
  async mounted () {
    this.$vs.loading({container: '#statusDataContainer'})

    document.title = this.$t('queues')

    const response = await Node.getServerAndNodeByLoggedInUser()
    this.server = response.data.server
    this.queueStatusNode = response.data.server.queue_status
    this.extensionNumber = this.$store.getters.extension
    if (this.extensionNumber === null) {
      this.extensionNumber = ''
    }

    // let socketScript = document.createElement('script')
    // socketScript.setAttribute('src', `${this.queueStatusNode.domain}:${this.queueStatusNode.port}/socket.io/socket.io.js`)
    // document.head.appendChild(socketScript)

    console.log(`${this.queueStatusNode.domain}:${this.queueStatusNode.port}/${this.queueStatusNode.pivot.namespace}`, { query: { queueno: this.queue }, transports: ['websocket'] })

    this.socket = io.connect(`${this.queueStatusNode.domain}:${this.queueStatusNode.port}/${this.queueStatusNode.pivot.namespace}`, { query: { queueno: this.queue }, transports: ['websocket'] })


    // Add a connect listener
    this.socket.on('connect', this.getInitialExtensions)
    this.socket.on('draw-initial-extensions', this.drawInitialExtensions)
    this.socket.on('message', this.getMessage)

    // new PerfectScrollbar('.extension-container', { // eslint-disable-line no-undef, no-new
    //   wheelSpeed: 2,
    //   wheelPropagation: true,
    //   minScrollbarLength: 20
    // })

    this.$vs.loading.close('#statusDataContainer > .con-vs-loading')
  },
  methods: {
    getInitialExtensions () {
      this.socket.emit('get-initial-extensions')
    },
    pullUpdatedExtensions () {
      this.extensions = []
      this.activeExtensions = []
      this.getInitialExtensions()
    },
    drawInitialExtensions (data) {
      const newExtensions = []
      const newActiveExtensions = []

      const storedExtData = sessionStorage.getItem('extensionData')
      const extData = storedExtData ? JSON.parse(storedExtData) : {}

      Object.values(data).forEach(item => {
        const extension = item.extensions

        const extensionData = {
          extension,
          name: '',
          color: '',
          status: '',
          text: '',
          time: '00:00:00',
          dndTime: extData[extension] && extData[extension].dndTime ? extData[extension].dndTime : null,
          tempStatus: false,
          enabled: false,
          rest: 0,
          lunch: 0,
          wrapup: 0,
          ready: 0,
          total: 0,
          inOrOut: '',
          displayInOrOut: false
        }

        newExtensions.push(extensionData)
        newActiveExtensions.push(item.extensions)
      })
      this.extensions = newExtensions
      this.activeExtensions = newActiveExtensions

    },
    getMessage (data) {
      if (data.api_type === 'status') {
        this.manageStatus(data)
      } else {
        this.manageQueueDetails(data)
      }
      this.isLoading = false
    },
    async getAgentName (key) {
      // Avoid Duplicate Calls
      this.cacheExt[this.extensions[key].extension] = {}

      const response = await User.showAgentName({ extension: this.extensions[key].extension })
      this.extensions[key].name = response.data.user
      this.cacheExt[this.extensions[key].extension] = response.data.user
    },
    async storeToSession (i) {
      const storedExtData = sessionStorage.getItem('extensionData')
      const extData = storedExtData ? JSON.parse(storedExtData) : {}
      extData[this.extensions[i].extension] = { dndTime: this.extensions[i].dndTime }
      sessionStorage.setItem('extensionData', JSON.stringify(extData))
    },
    async manageStatus (data) {
      const now = new Moment() // eslint-disable-line new-cap

      for (const i in this.extensions) {
        const index = data.extensions.indexOf(this.extensions[i].extension)
        this.extensions[i].color = data.results[this.extensions[i].extension].color
        this.extensions[i].status = data.results[this.extensions[i].extension].status
        this.extensions[i].text = data.results[this.extensions[i].extension].text
        this.extensions[i].time = data.results[this.extensions[i].extension].time
        this.extensions[i].inOrOut = data.results[this.extensions[i].extension].inout
        this.extensions[i].displayInOrOut = data.results[this.extensions[i].extension].displayInOrOut

        // Get Agent Name
        if (this.cacheExt.hasOwnProperty(this.extensions[i].extension)) {
          this.extensions[i].name = this.cacheExt[this.extensions[i].extension]
        } else {
          this.getAgentName(i)
        }

        let socketStatus = null

        switch (parseInt(this.extensions[i].status)) {
        case 11:
          socketStatus = 11
          if (this.extensions[i].tempStatus !== 11 && this.extensions[i].dndTime === null) {
            this.extensions[i].dndTime = new Moment() // eslint-disable-line new-cap
            this.storeToSession(i)
          }
          break
        case 21:
          socketStatus = 21
          if (this.extensions[i].tempStatus !== 21 && this.extensions[i].dndTime === null) {
            this.extensions[i].dndTime = new Moment() // eslint-disable-line new-cap
            this.storeToSession(i)
          }
          break
        case 31:
          socketStatus = 31
          if (this.extensions[i].tempStatus !== 31 && this.extensions[i].dndTime === null) {
            this.extensions[i].dndTime = new Moment() // eslint-disable-line new-cap
            this.storeToSession(i)
          }
          break
        case 32:
        case 22:
        case 12:
        case 0:
          socketStatus = 32
          if (this.extensions[i].tempStatus !== 32 && this.extensions[i].dndTime === null) {
            this.extensions[i].dndTime = new Moment() // eslint-disable-line new-cap
            this.storeToSession(i)
          }
          break
        default:
          socketStatus = null
          this.extensions[i].dndTime = null
          this.storeToSession(i)
        }

        this.extensions[i].tempStatus = socketStatus

        if (data.time[index] === '&nbsp;') {
          const duration = Moment.duration(now.diff(this.extensions[i].dndTime))
          const dndTime = `${duration._data.hours.toString().padStart(2, '0')  }:${  duration._data.minutes.toString().padStart(2, '0')  }:${  duration._data.seconds.toString().padStart(2, '0')}`

          if (this.extensions[i].tempStatus !== null) {
            this.extensions[i].time = dndTime
          }
        }

        this.extensions[i].enabled = [11, 21, 31].indexOf(parseInt(data.status[index])) !== -1

      }

    },
    manageQueueDetails (data) {
      const tempAsf = (this.queueDetails.answeredCalls * 100 / (this.queueDetails.answeredCalls + this.queueDetails.droppedCalls))
      const tempTsf = (this.queueDetails.answeredCalls * parseFloat(data.service_level) / (this.queueDetails.answeredCalls + this.queueDetails.droppedCalls))

      this.queueDetails.answeredCalls = (isNaN(data.calls_answered) || data.calls_answered == '') ? 0 : parseInt(data.calls_answered)
      this.queueDetails.droppedCalls = (isNaN(data.calls_notanswered) || data.calls_notanswered == '') ? 0 : parseInt(data.calls_notanswered)
      this.queueDetails.asf = (isNaN(tempAsf) || tempAsf == '') ? '0.00' : tempAsf.toFixed(2)
      this.queueDetails.tsf = (isNaN(tempTsf) || tempTsf == '') ? '0.00' : tempTsf.toFixed(2)
      this.queueDetails.slt = ''
      if (data.service_level != '') {
        this.queueDetails.slt = data.service_level.split('within')[1].trim().replace('s', '')
      }

      this.queueDetails.strategy = data.strategy

      this.queueDetails.totalCalls = (data.noofcalls == '') ? 0 : parseInt(data.noofcalls)
      this.queueDetails.holdTime = (data.holdtime == '') ? '00:00:00' : data.holdtime
      this.queueDetails.talkTime = (data.talktime == '') ? '00:00:00' : data.talktime

      this.queueDetails.totalIncomingCalls = this.queueDetails.answeredCalls + this.queueDetails.droppedCalls
    }
  }
}
</script>

<style lang="scss" scoped>
  #statusDataContainer {
    min-height: 400px;
  }
</style>
